import { API_BASE } from '../env'
import { request } from './http'
import type { Refine, Schema } from './schema'

// ── Needs attention ──────────────────────────────────────────────────────────────────────────────

export type AttentionKind =
  | 'rollout_paused'
  | 'rollout_ready_to_continue'
  | 'rollout_failures'
  | 'drift_decision'
  | 'stale_draft'
  | 'provisioning_pending_approval'
  | 'provisioning_quarantined'
  | 'provisioning_claim_spike'
  | 'provisioning_claim_near_limit'
  | 'provisioning_pairing_pool'
  | 'agent_link_unencrypted'

/**
 * One thing that needs a person. Every item has the hub's five fields; provisioning's items add the
 * optional extras below (the relay omits the nulls). `link.id` is always a string — a uuid, or a
 * word such as `"quarantined"` or `"pool"` for a link to a list rather than a record.
 *
 * Provisioning link types: `provisioning_queue` (id: a brand id, or `"quarantined"`),
 * `provisioning_device` (a device row id), `claim` (a claim id), `provisioning_pairing` (`"pool"`).
 * `agent_link_unencrypted` links `devices_unencrypted` with a brand id, and carries the brand and a count.
 *
 * - `kind`: `string & {}` keeps the known kinds offered by the editor while still accepting a new
 *   one.
 * - `count`: Devices waiting (pending approval), showing a pairing code (pairing pool), or
 *   connected without encryption (agent_link_unencrypted).
 * - `since`: When the oldest of them started waiting, or when the device was quarantined.
 * - `device_id`: The quarantined device's `device_id`.
 * - `reason`: Why it was quarantined: serial_spoof, same_key_different_hardware, … (see
 *   `quarantineReasonLabel`).
 */
export type AttentionItemWire = Refine<
  Schema<'AttentionItemWire'>,
  {
    severity: 'warning' | 'info'
  }
>

export function getAttention(): Promise<{ count: number; items: AttentionItemWire[] }> {
  return request<{ count: number; items: AttentionItemWire[] }>('GET', `${API_BASE}/attention`)
}
